@use "~components/Avatar/tokens" as avatar-tokens;
@use "~theme/typography";

.slots {
  margin-top: 18px;
  display: flex;
  flex-flow: row wrap;
}

.doctor {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.imageContainer {
  display: flex;
  margin-right: 20px;
  height: avatar-tokens.$size;
  width: avatar-tokens.$size;
  justify-content: center;
  align-items: center;
}

.doctorDetails {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.availability {
  @include typography.body;
  margin-top: 18px;
  color: var(--blue-02);
  text-transform: capitalize;
}

.noAvailability {
  color: var(--black-at-75);
}

.action {
  display: flex;
  margin-top: 18px;
  width: 100%;
}
